export default __webpack_public_path__ + "media/images/metrica_icon-d4ceb7473a1e73428c05407ff2cb37d4.png";